import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './Support.css';

const Support = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    email: user?.email || '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await api.post('/api/v1/support/contact', formData);
      setMessage('Support request submitted successfully! We\'ll get back to you soon.');
      setFormData({ email: user?.email || '', subject: '', message: '' });
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit support request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="support-container">
      <div className="card">
        <h1>Contact Support</h1>
        <p>Have a question or need help? Send us a message and we&apos;ll get back to you as soon as possible.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading || !!user}
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              disabled={loading}
              maxLength={200}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows={6}
              required
              disabled={loading}
              minLength={10}
              maxLength={2000}
            />
            <small>{formData.message.length} / 2000 characters</small>
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Support;
